import { useAbortCampaignMutation } from 'modules/campaigns/lib';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { ModalType, useCampaignContext, useModalContext } from '../../context';
import { useCancelCampaignAlerts } from '../../hooks/useCancelCampaignAlerts';
import { maybeRestErrorMessage } from '../../utils';
import { getAbortCampaignPayload } from './AbortCampaignModal.utils';

export const useAbortCampaign = () => {
  const { closeModal } = useModalContext();
  const { isLoading, mutate, error } = useAbortCampaignMutation();
  const { cancelCampaignAlerts } = useCancelCampaignAlerts();

  const dispatch = useDispatch();

  const { campaign, refetch: refetchCampaign } = useCampaignContext();
  const { campaignAlertsEnabled, id, name } = campaign;

  const abortCampaign = () => {
    const onSuccess = () => {
      cancelCampaignAlerts({
        campaignIds: [id],
        campaignAlertsEnabled,
      });

      dispatch(addPositiveToast(`${name} aborted successfully.`));
      closeModal(ModalType.AbortCampaignModal);
      refetchCampaign();
    };

    const onError = (e: unknown) => {
      const errorResponseMessage = maybeRestErrorMessage(e);
      const defaultErrorMessage = 'Error aborting campaign: something went wrong.';
      const errorMessage = errorResponseMessage || defaultErrorMessage;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'abortCampaign', e));
    };

    const payload = getAbortCampaignPayload(campaign);

    mutate(payload, {
      onSuccess,
      onError,
    });
  };

  return { isLoading, error, abortCampaign };
};
